module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.role !== 'Supplier' && _vm.role !== '') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.suppliers,
      "label": "Select a Supplier",
      "item-text": "name",
      "item-value": "key",
      "clearable": ""
    },
    model: {
      value: (_vm.supplierSelect),
      callback: function($$v) {
        _vm.supplierSelect = $$v
      },
      expression: "supplierSelect"
    }
  })], 1), _vm._v(" "), (_vm.supplier === undefined) ? [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("OR")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "block": "",
      "to": "/Admin/Supplier"
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Add New Supplier\n        ")], 1)], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('v-tabs', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fixed-tabs": "",
      "slider-color": "primary"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_vm._l((['Invoices', 'Jobs']), function(n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "ripple": ""
      }
    }, [(n === 'Invoices' || _vm.supplier) ? [_vm._v("\n          " + _vm._s(n) + "\n        ")] : _vm._e()], 2)
  }), _vm._v(" "), _c('v-tab-item', {
    key: "Invoices"
  }, [_c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-card-title', [_c('div', {
    staticStyle: {
      "max-width": "440px"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Filter Invoice Status",
      "items": _vm.invoiceStatuses,
      "multiple": "",
      "chips": "",
      "deletable-chips": ""
    },
    model: {
      value: (_vm.invoiceStatusFilter),
      callback: function($$v) {
        _vm.invoiceStatusFilter = $$v
      },
      expression: "invoiceStatusFilter"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchInvoices),
      callback: function($$v) {
        _vm.searchInvoices = $$v
      },
      expression: "searchInvoices"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.invoiceHeaders,
      "items": _vm.modifiedInvoices,
      "search": _vm.searchInvoices,
      "pagination": _vm.pagination,
      "item-key": "id"
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_c('a', {
          on: {
            "click": function($event) {
              _vm.supplierSelect = props.item.supplier
            }
          }
        }, [_vm._v(_vm._s(props.item.supplierText))])]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.invoiceNumber))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(_vm._f("formatDate")(props.item.submittedDate)))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(_vm._f("formatDate")(props.item.lastActioned)))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.lastUser))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.lastNote))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.currency) + _vm._s(props.item.cost))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.statusText))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [(_vm.role !== 'Supplier') ? _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.openInvoiceStatus(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "success"
          }
        }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
          attrs: {
            "href": props.item.attachedDocs[0].downloadUrl,
            "target": "_blank",
            "icon": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("mdi-file-document")])], 1)], 1)])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-layout', {
          attrs: {
            "justify-center": ""
          }
        }, [(props.item.history) ? _c('v-card', {
          staticClass: "ma-2"
        }, [_c('v-card-title', [_vm._v("\n                    Invoice History\n                  ")]), _vm._v(" "), _c('table', {
          staticStyle: {
            "width": "100%"
          }
        }, [_c('thead', {
          staticClass: "text-xs-left"
        }, [_c('th', [_vm._v("User")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Note")])]), _vm._v(" "), _c('tbody', [_vm._l((props.item.history), function(record, i) {
          return [_c('tr', {
            key: i
          }, [_c('td', [_vm._v(_vm._s(record.user))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("invoiceStatus")(record.status)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(record.date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.note))])])]
        })], 2)])], 1) : _vm._e(), _vm._v(" "), (_vm.supplier) ? _c('v-card', {
          staticClass: "ma-2"
        }, [_c('v-card-title', [_vm._v("\n                    Invoiced Jobs\n                  ")]), _vm._v(" "), _c('table', [_c('thead', {
          staticClass: "text-xs-left"
        }, [_c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("Vehicle")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Engineer")]), _vm._v(" "), _c('th', [_vm._v("Project")]), _vm._v(" "), _c('th', [_vm._v("Job No")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Cost")])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.invoicedJobs), function(job) {
          return [(job.invoiceNumber === props.item.invoiceNumber) ? _c('tr', {
            key: job.jobNo
          }, [_c('td', [_vm._v(_vm._s(job.filteredCustomer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(job.Vehicle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(job.Date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(job.filteredAllocated))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(job.Project))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(job.JobNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("jobStatus")(job.Status, job.filteredAllocated)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(job.currency || '£') + _vm._s(job.cost || 0))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-right"
          }, [(job.Status > 1) ? _c('v-btn', {
            staticClass: "mx-0",
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.viewJob(job.id)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "primary"
            }
          }, [_vm._v("assignment_turned_in")])], 1) : _vm._e()], 1)]) : _vm._e()]
        })], 2)])], 1) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.supplier) ? _c('v-tab-item', {
    key: "Jobs"
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.summaryCards), function(card, i) {
    return _c('v-flex', {
      key: i
    }, [_c('v-card', {
      staticClass: "pa-2 ma-1 text-xs-center"
    }, [_c('v-progress-circular', {
      attrs: {
        "size": 70,
        "width": 10,
        "rotate": 360,
        "value": _vm.states[i] / _vm.totalJobs * 100,
        "color": card.color
      }
    }, [_vm._v("\n                " + _vm._s(_vm.states[i]) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(card.title))])], 1)], 1)
  }), 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-card-title', [_c('v-btn', {
    attrs: {
      "icon": "",
      "flat": "",
      "color": "primary",
      "to": '/Calendar/' + _vm.supplier
    }
  }, [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-width": "440px"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Filter Invoice Status",
      "items": _vm.jobInvoiceStatuses,
      "multiple": "",
      "chips": "",
      "deletable-chips": ""
    },
    model: {
      value: (_vm.jobInvoiceStatusFilter),
      callback: function($$v) {
        _vm.jobInvoiceStatusFilter = $$v
      },
      expression: "jobInvoiceStatusFilter"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-width": "440px"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Filter Job Status",
      "items": _vm.jobStatuses,
      "multiple": "",
      "chips": "",
      "deletable-chips": ""
    },
    model: {
      value: (_vm.jobStatusFilter),
      callback: function($$v) {
        _vm.jobStatusFilter = $$v
      },
      expression: "jobStatusFilter"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.modifiedJobs,
      "search": _vm.search,
      "pagination": _vm.pagination,
      "item-key": "id",
      "select-all": "",
      "loading": _vm.tableLoading
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": ""
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.filteredCustomer))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.Vehicle))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = props.item.Status >= 1 ? !props.expanded : props.expanded
            }
          }
        }, [(props.item.Status < 1) ? _c('v-edit-dialog', {
          attrs: {
            "return-value": _vm.updateDate,
            "lazy": "",
            "large": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              _vm.updateDate = $event
            },
            "update:return-value": function($event) {
              _vm.updateDate = $event
            },
            "save": function($event) {
              return _vm.updateJob(props.item, true)
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function() {
              return [_c('v-date-picker', {
                staticStyle: {
                  "box-shadow": "none"
                },
                attrs: {
                  "no-title": "",
                  "value": _vm.jobs[props.item.index].Date,
                  "scrollable": ""
                },
                on: {
                  "change": function (v) { return _vm.updateDate = v; }
                }
              })]
            },
            proxy: true
          }], null, true)
        }, [_c('div', {
          staticStyle: {
            "border-bottom": "2px #106172 solid"
          }
        }, [_vm._v(_vm._s(_vm._f("formatDate")(props.item.Date)))])]) : _c('div', [_vm._v(_vm._s(_vm._f("formatDate")(props.item.Date)))])], 1), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = props.item.Status >= 1 ? !props.expanded : props.expanded
            }
          }
        }, [(props.item.Status < 1) ? _c('v-edit-dialog', {
          attrs: {
            "return-value": _vm.updateAllocated,
            "lazy": "",
            "large": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              _vm.updateAllocated = $event
            },
            "update:return-value": function($event) {
              _vm.updateAllocated = $event
            },
            "save": function($event) {
              return _vm.updateJob(props.item, true)
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function() {
              return [_c('v-select', {
                attrs: {
                  "no-title": "",
                  "value": _vm.jobs[props.item.index].Allocated,
                  "items": _vm.supplierSelectEngineers,
                  "item-text": "name",
                  "item-value": "key"
                },
                on: {
                  "change": function (v) { return _vm.updateAllocated = v; }
                }
              })]
            },
            proxy: true
          }], null, true)
        }, [_c('div', {
          staticStyle: {
            "border-bottom": "2px #106172 solid"
          }
        }, [_vm._v(_vm._s(props.item.filteredAllocated))])]) : _c('div', [_vm._v(_vm._s(props.item.filteredAllocated))])], 1), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.Project))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.JobNo))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(_vm._f("jobStatus")(props.item.Status, props.item.filteredAllocated)))]), _vm._v(" "), _c('td', [(props.item.invoiceStatusNumber == -2) ? _c('v-edit-dialog', {
          attrs: {
            "return-value": _vm.updateCurrency,
            "lazy": "",
            "large": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              _vm.updateCurrency = $event
            },
            "update:return-value": function($event) {
              _vm.updateCurrency = $event
            },
            "save": function($event) {
              return _vm.updateJob(props.item, true)
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function() {
              return [_c('v-select', {
                attrs: {
                  "value": _vm.jobs[props.item.index].currency || '£',
                  "items": ['£', '€']
                },
                on: {
                  "change": function (v) { return _vm.updateCurrency = v; }
                }
              })]
            },
            proxy: true
          }], null, true)
        }, [_c('div', {
          staticStyle: {
            "border-bottom": "2px #106172 solid"
          }
        }, [_vm._v(_vm._s(props.item.currency || '£'))])]) : _c('div', [_vm._v(_vm._s(props.item.currency || '£'))])], 1), _vm._v(" "), _c('td', [(props.item.invoiceStatusNumber == -2) ? _c('v-edit-dialog', {
          attrs: {
            "return-value": _vm.updateCost,
            "lazy": "",
            "large": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              _vm.updateCost = $event
            },
            "update:return-value": function($event) {
              _vm.updateCost = $event
            },
            "save": function($event) {
              return _vm.updateJob(props.item, true)
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function() {
              return [_c('v-text-field', {
                attrs: {
                  "value": _vm.jobs[props.item.index].cost || '0',
                  "type": "number"
                },
                on: {
                  "change": function (v) { return _vm.updateCost = v; }
                }
              })]
            },
            proxy: true
          }], null, true)
        }, [_c('div', {
          staticStyle: {
            "border-bottom": "2px #106172 solid"
          }
        }, [_vm._v(_vm._s(props.item.cost || 0))])]) : _c('div', [_vm._v(_vm._s(props.item.cost || 0))])], 1), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.invoiceStatus))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.invoiceNumber))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [(props.item.jobStarted && props.item.Status == 0) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-btn', _vm._g({
                staticClass: "mx-0",
                attrs: {
                  "icon": ""
                }
              }, on), [_c('v-icon', {
                attrs: {
                  "color": "blue"
                }
              }, [_vm._v("account_box")])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Engineer has started this job but not sent it back to portal yet")])]) : _vm._e(), _vm._v(" "), (props.item.Status > 0) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.viewJob(props.item.id)
            }
          }
        }, [(props.item.Status > 2) ? _c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("assignment_turned_in")]) : (props.item.Status == 2) ? _c('v-icon', {
          attrs: {
            "color": "success"
          }
        }, [_vm._v("assignment_ind")]) : _c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("assignment_late")])], 1) : _vm._e(), _vm._v(" "), (props.item.Status < 2) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.completeJob(props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "green"
          }
        }, [_vm._v("check")])], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-layout', {
          attrs: {
            "justify-center": ""
          }
        }, [_c('v-card', {
          staticClass: "ma-2"
        }, [_c('v-list', {
          attrs: {
            "dark": "",
            "dense": ""
          }
        }, _vm._l((props.item.templates), function(template, i) {
          return _c('v-list-tile', {
            key: i
          }, [_c('v-list-tile-action', [_c('v-checkbox', {
            attrs: {
              "disabled": "",
              "input-value": "true"
            }
          })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.templates.find(function (t) {
            return t.id === template
          }).name))])], 1)], 1)
        }), 1)], 1)], 1)]
      }
    }], null, false, 3077615135),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('completed-view', {
    attrs: {
      "visible": _vm.viewDialog,
      "JobID": _vm.currentJob
    },
    on: {
      "update:visible": function($event) {
        _vm.viewDialog = $event
      }
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.addToProjectDialog),
      callback: function($$v) {
        _vm.addToProjectDialog = $$v
      },
      expression: "addToProjectDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Assign Jobs to Project\n      ")]), _vm._v(" "), _c('v-card-text', [_c('v-form', [_c('v-select', {
    attrs: {
      "label": "Assign to Project",
      "items": _vm.projects,
      "item-text": "projectId",
      "item-value": "projectId"
    },
    model: {
      value: (_vm.assignToProject),
      callback: function($$v) {
        _vm.assignToProject = $$v
      },
      expression: "assignToProject"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Jobs to be assigned")]), _vm._v(" "), (_vm.selected) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.selected), function(job, index) {
    return _c('v-list-tile', {
      key: index
    }, [_vm._v("\n              " + _vm._s(job.JobNo) + "\n            ")])
  }), 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "loading": _vm.savingAddJobsToProject
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addJobsToProject($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.addToProjectDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.assignToEngineerDialog),
      callback: function($$v) {
        _vm.assignToEngineerDialog = $$v
      },
      expression: "assignToEngineerDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Assign Jobs to Engineer")])]), _vm._v(" "), _c('v-card-text', [_c('v-form', [_c('v-autocomplete', {
    attrs: {
      "label": "Assign to Supplier",
      "items": _vm.suppliers,
      "item-text": "name",
      "item-value": "key",
      "disabled": ""
    },
    model: {
      value: (_vm.supplier),
      callback: function($$v) {
        _vm.supplier = $$v
      },
      expression: "supplier"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Assign to Engineer",
      "items": _vm.assignToSupplierEngineers,
      "item-text": "name",
      "item-value": "key",
      "loading": _vm.gettingEngineers,
      "clearable": "",
      "disabled": !_vm.supplier
    },
    model: {
      value: (_vm.assignToEngineer),
      callback: function($$v) {
        _vm.assignToEngineer = $$v
      },
      expression: "assignToEngineer"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Jobs to be assigned")]), _vm._v(" "), (_vm.selected) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.selected), function(job, index) {
    return _c('v-list-tile', {
      key: index
    }, [_vm._v("\n              " + _vm._s(job.JobNo) + "\n            ")])
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.supplier) ? _c('h5', {
    staticClass: "error--text"
  }, [_vm._v("A Supplier must be assigned to the selected jobs parent project")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "loading": _vm.savingAssignJobsToEngineer,
      "disabled": !_vm.supplier
    },
    nativeOn: {
      "click": function($event) {
        return _vm.assignJobsToEngineer($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.assignToEngineerDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": "",
      "persistent": ""
    },
    model: {
      value: (_vm.bulkUpdateCostDialog),
      callback: function($$v) {
        _vm.bulkUpdateCostDialog = $$v
      },
      expression: "bulkUpdateCostDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Update Cost\n      ")]), _vm._v(" "), _c('v-card-text', [_c('v-select', {
    attrs: {
      "label": "Currency",
      "items": ['£', '€']
    },
    model: {
      value: (_vm.bulkUpdateCurrency),
      callback: function($$v) {
        _vm.bulkUpdateCurrency = $$v
      },
      expression: "bulkUpdateCurrency"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.bulkUpdateCost),
      callback: function($$v) {
        _vm.bulkUpdateCost = $$v
      },
      expression: "bulkUpdateCost"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success darken-1",
      "loading": _vm.updatingCosts,
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateCosts($event)
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.bulkUpdateCostDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.invoiceStatusDialog),
      callback: function($$v) {
        _vm.invoiceStatusDialog = $$v
      },
      expression: "invoiceStatusDialog"
    }
  }, [(_vm.activeInvoice) ? _c('v-card', [_c('v-card-title', [_vm._v("\n        Invoice Status\n      ")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v("Invoice: " + _vm._s(_vm.activeInvoice.invoiceNumber))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Invoice Status",
      "items": _vm.invoiceStatuses
    },
    model: {
      value: (_vm.activeInvoice.status),
      callback: function($$v) {
        _vm.$set(_vm.activeInvoice, "status", $$v)
      },
      expression: "activeInvoice.status"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Note"
    },
    model: {
      value: (_vm.activeInvoice.note),
      callback: function($$v) {
        _vm.$set(_vm.activeInvoice, "note", $$v)
      },
      expression: "activeInvoice.note"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success darken-1",
      "loading": _vm.savingInvoice,
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveInvoice($event)
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.invoiceStatusDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.completeDialog),
      callback: function($$v) {
        _vm.completeDialog = $$v
      },
      expression: "completeDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Complete Job")])]), _vm._v(" "), _c('v-card-text', [_c('h4', [_vm._v("You are about to complete job " + _vm._s(_vm.currentJobNo) + ".")]), _vm._v(" "), (_vm.jobs.find(function (job) {
    return job.id === this$1.currentJob
  })) ? [_c('h5', [_vm._v("Job Attachments")]), _vm._v(" "), _vm._l((_vm.jobs.find(function (job) {
    return job.id === this$1.currentJob
  }).completedDocs), function(doc) {
    return _c('v-list-tile', {
      key: doc.name
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("mdi-file-document-outline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('a', {
      attrs: {
        "href": doc.downloadUrl,
        "target": "_BLANK"
      }
    }, [_vm._v(_vm._s(doc.name))])])], 1)], 1)
  })] : _vm._e(), _vm._v(" "), _c('upload-btn', {
    attrs: {
      "uniqueId": "",
      "title": 'Attach New Document',
      "fileChangedCallback": _vm.attachCompletedFile
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-paperclip")])], 1)], 2), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "color": _vm.fileProgress === 100 ? 'success' : 'primary',
      "value": _vm.fileProgress
    }
  })], 2), _vm._v(" "), (_vm.jobs.find(function (job) {
    return job.id === this$1.currentJob
  })) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "flat": "",
      "loading": _vm.completingJob,
      "disabled": _vm.jobs.find(function (job) {
        return job.id === this$1.currentJob
      }).Status < 1 && !_vm.jobs.find(function (job) {
        return job.id === this$1.currentJob
      }).completedDocs
    },
    nativeOn: {
      "click": function($event) {
        return _vm.completeCurrentJob($event)
      }
    }
  }, [_vm._v("\n          Complete Job\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "right": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.completeDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "scrollable": "",
      "persistent": ""
    },
    model: {
      value: (_vm.createInvoiceDialog),
      callback: function($$v) {
        _vm.createInvoiceDialog = $$v
      },
      expression: "createInvoiceDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', [_vm._v("Add Invoice")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.createInvoiceDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v("You are about to add an invoice for the following jobs")]), _vm._v(" "), (_vm.selected) ? _c('table', {
    staticStyle: {
      "text-align": "left",
      "width": "100%"
    }
  }, [_c('thead', [_c('th', [_vm._v("Job No")]), _vm._v(" "), _c('th', [_vm._v("Vehicle")]), _vm._v(" "), _c('th', [_vm._v("Cost")])]), _vm._v(" "), _vm._l((_vm.selected), function(job, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(job.JobNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(job.Vehicle))]), _vm._v(" "), _c('td', [(job.saving) ? _c('v-progress-circular', {
      attrs: {
        "size": "20",
        "width": "2",
        "indeterminate": "",
        "color": "primary"
      }
    }) : _c('v-edit-dialog', {
      attrs: {
        "return-value": _vm.updateCost,
        "lazy": "",
        "large": "",
        "persistent": ""
      },
      on: {
        "update:returnValue": function($event) {
          _vm.updateCost = $event
        },
        "update:return-value": function($event) {
          _vm.updateCost = $event
        },
        "save": function($event) {
          return _vm.updateJob(job, false)
        }
      },
      scopedSlots: _vm._u([{
        key: "input",
        fn: function() {
          return [_c('v-text-field', {
            attrs: {
              "value": job.cost || '0',
              "type": "number"
            },
            on: {
              "change": function (v) { return _vm.updateCost = v; }
            }
          })]
        },
        proxy: true
      }], null, true)
    }, [_c('div', {
      staticStyle: {
        "border-bottom": "2px #106172 solid"
      }
    }, [_vm._v(_vm._s(job.currency || '£') + _vm._s(job.cost || '-'))])])], 1)])
  }), _vm._v(" "), _c('tfoot', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.selected[0] && _vm.selected[0].currency ? _vm.selected[0].currency : '£') + _vm._s(_vm.totalSelectedCost))])])], 2) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Before uploading your invoice please check the total cost matches above.")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outline": "",
      "label": "Invoice Number"
    },
    model: {
      value: (_vm.invoiceNumber),
      callback: function($$v) {
        _vm.invoiceNumber = $$v
      },
      expression: "invoiceNumber"
    }
  }), _vm._v(" "), _c('upload-btn', {
    attrs: {
      "disabled": !_vm.invoiceNumber,
      "uniqueId": "",
      "title": 'Upload Invoice',
      "fileChangedCallback": _vm.uploadInvoice
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-file-document")])], 1)], 2), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "color": _vm.fileProgress === 100 ? 'success' : 'primary',
      "value": _vm.fileProgress
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-speed-dial', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected.length > 0),
      expression: "selected.length > 0"
    }],
    attrs: {
      "bottom": "",
      "right": "",
      "fixed": ""
    },
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": "",
      "fab": "",
      "hover": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-icon', [_vm._v("edit")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips,
      "color": "cyan"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "cyan"
    },
    on: {
      "click": function($event) {
        _vm.assignToEngineerDialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("assignment_ind")])], 1), _vm._v(" "), _c('span', [_vm._v("Assign Engineer")])], 1), _vm._v(" "), (_vm.allNotInvoiced) ? _c('v-tooltip', {
    attrs: {
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips,
      "color": "purple"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "purple"
    },
    on: {
      "click": function($event) {
        _vm.bulkUpdateCostDialog = true
      }
    },
    slot: "activator"
  }, [_vm._v("\n          £\n        ")]), _vm._v(" "), _c('span', [_vm._v("Add Cost")])], 1) : _vm._e(), _vm._v(" "), (_vm.allNotInvoiced) ? _c('v-tooltip', {
    attrs: {
      "disabled": _vm.tooltipsDisabled,
      "left": "",
      "value": _vm.tooltips,
      "color": "success"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "fab": "",
      "dark": "",
      "small": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        _vm.createInvoiceDialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("mdi-file-document")])], 1), _vm._v(" "), _c('span', [_vm._v("Add Invoice")])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2a1b6ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supplier.vue
// module id = 761
// module chunks = 1